import React from 'react';
import PropTypes from 'prop-types';
import './Card.css';

/**
 * Card — the DS M2 card surface (`.ds-card`): gray-025 fill, gray-0 hairline,
 * `--radius-card`, `--shadow-card-m2`; `interactive` adds the pointer hover
 * (gray-5 stroke + popup shadow), `selected` the gray-10 stroke.
 *
 * The surface that PatchCard, TextCard, ImageSelector, the ContentBannerV2
 * mosaic, BentoGrid, OrderCard and EmptyState's art well share — one place
 * for the tokens instead of a copy per component. Cards with their own
 * buttons inside (zoom, edit, add) cannot be a <button>; they render a
 * `.ds-card__hit` button stretched over the card for the main click.
 */
const Card = ({ as: Tag = 'div', interactive = false, selected = false, className = '', children, ...rest }) => {
  const classes = [
    'ds-card',
    interactive && 'ds-card--interactive',
    selected && 'ds-card--selected',
    className,
  ].filter(Boolean).join(' ');
  return (
    <Tag className={classes} {...rest}>
      {children}
    </Tag>
  );
};

Card.propTypes = {
  /** Element to render — 'div' by default; 'article', 'li', 'figure', 'button'… */
  as: PropTypes.elementType,
  /** Hover feedback for a card that reacts to the pointer */
  interactive: PropTypes.bool,
  /** Selected state — gray-10 stroke */
  selected: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default Card;
